export default {
  imgs: [
    {
      name: "底部弹窗背景",
      src: require("@img/modal/modal-bg.png"),
    },
    {
      name: "弹窗关闭按钮",
      src: require("@img/modal/modal-close.png"),
    },
    {
      name: "底部弹窗头部",
      src: require("@img/modal/head-bg.png"),
    },
    {
      name: "底部弹窗头部激活",
      src: require("@img/modal/head-bg-active.png"),
    },
    {
      name: "任务背景",
      src: require("@img/modal/task-bg.png"),
    },
    {
      name: "按钮0",
      src: require("@img/modal/btn-0.png"),
    },
    {
      name: "按钮1",
      src: require("@img/modal/btn-1.png"),
    },
    {
      name: "按钮2",
      src: require("@img/modal/btn-2.png"),
    },
    {
      name: "按钮3",
      src: require("@img/modal/btn-3.png"),
    },
    {
      name: "弹窗头",
      src: require("@img/modal/modal-center-top.png"),
    },
    {
      name: "弹窗内容背景",
      src: require("@img/modal/modal-center-center.png"),
    },
    {
      name: "弹窗底部",
      src: require("@img/modal/modal-center-bottom.png"),
    },
    {
      name: "弹窗关闭",
      src: require("@img/modal/modal-close.png"),
    },
    {
      name: "蛋",
      src: require("@img/modal/egg.png"),
    },
    {
      name: "蛋背景",
      src: require("@img/modal/egg-bg.png"),
    },
    {
      name: "弹窗按钮",
      src: require("@img/modal/modal-confirm.png"),
    },
    {
      name: "宠物背包种开蛋按钮",
      src: require("@img/modal/pet-default.png"),
    },
    {
      name: "宠物包裹宠物名牌-0",
      src: require("@img/modal/pet-bg-name0.png"),
    },
    {
      name: "宠物包裹宠物名牌-1",
      src: require("@img/modal/pet-bg-name1.png"),
    },
    {
      name: "宠物包裹宠物名牌-2",
      src: require("@img/modal/pet-bg-name2.png"),
    },
    {
      name: "宠物包裹宠物名牌-3",
      src: require("@img/modal/pet-bg-name3.png"),
    },
    {
      name: "宠物包裹宠物名牌-4",
      src: require("@img/modal/pet-bg-name4.png"),
    },
    {
      name: "宠物包裹格子背景",
      src: require("@img/modal/pet-bg.png"),
    },
    {
      name: "宠物命名输入框",
      src: require("@img/modal/rename-bg.png"),
    },
    {
      name: "自定义弹窗头部1",
      src: require("@img/modal/modal-custom-top1.png"),
    },
    // v2.0
    {
      name: "对话组件旁白背景",
      src: require("@img/modal/pb-bg.png"),
    },
    {
      name: "npc图片",
      src: require("@img/pets/npc.png"),
    },
    // v2.0 end
  ],
};
